import React from "react";



export default function RegisterBar(props) {
    const gid = props.gid;
    const openAppUrl = `https://fitgames.tw/applink?type=9&gid=${gid}`;

    const handleOpenApp = () => {
        window.open(openAppUrl, "_self");
    }

    return (
        <div className="game-register-outter-box">
            <button className="game-register-btn" onClick={() => handleOpenApp()}>立即報名</button>
        </div>
    );
}
